import log from 'salvo-lite/log'

class ChangeClass {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = JSON.parse(elem.getAttribute('data-change-class'))
        this._triggerElem = this._data.elem
        this._class = this._data.class
        this._action = this._data.action || false
        this._trigger = this._data.trigger || false
        this._removeFromSiblings = this._data.removeFromSiblings || false
        this._maxWidth = this._data.maxWidth || 999999999
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        if (this._trigger === 'input') {
            if (window.innerWidth <= this._maxWidth) {
                this._elem.addEventListener('focus', () => {
                    this.getElements()
                })
                this._elem.addEventListener('blur', () => {
                    this.getElements('remove')
                })
            }
        } else {
            this._elem.addEventListener('click', () => {
                if (window.innerWidth <= this._maxWidth) {
                    this.getElements()
                    this.removeClassFromSiblings()
                }
            })
        }
    }

    getElements (action) {
        if (Array.isArray(this._triggerElem)) {
            for (var i = 0; i < this._triggerElem.length; i++) {
                let className
                if (Array.isArray(this._class)) {
                    className = this._class[i]
                } else {
                    className = this._class
                }
                const classChangeAction = action || this._action[i]
                this.changeClass(this._triggerElem[i], classChangeAction, className)
            }
        } else {
            const classChangeAction = action || this._action
            this.changeClass(this._triggerElem, classChangeAction, this._class)
        }
    }

    changeClass (trigger, action, className) {
        if (trigger === 'parent') {
            trigger = this._elem.parentNode
        } else if (trigger === 'self') {
            trigger = this._elem
        } else if (trigger === 'prev') {
            trigger = this._elem.previousElementSibling
        } else if (trigger === 'next') {
            trigger = this._elem.nextElementSibling
        } else {
            trigger = document.querySelector(trigger)
        }
        if (action === 'toggle') {
            if (trigger.classList.contains(className)) {
                trigger.classList.remove(className)
            } else {
                if (!trigger.classList.contains(className)) {
                    trigger.classList.add(className)
                }
            }
        } else if (action === 'remove') {
            if (trigger.classList.contains(className)) {
                trigger.classList.remove(className)
            }
        } else if (action === 'add') {
            if (!trigger.classList.contains(className)) {
                trigger.classList.add(className)
            }
        } else {
            if (!trigger.classList.contains(className)) {
                trigger.classList.add(className)
            }
        }
    }

    removeClassFromSiblings () {
        if (this._removeFromSiblings) {
            let siblings = this._elem.parentNode.querySelectorAll(this._removeFromSiblings.selector) || null
            if (siblings.length === 0) {
                siblings = this._elem.parentNode.children
            }
            for (var i = 0; i < siblings.length; i++) {
                if (siblings[i] !== this._elem) {
                    siblings[i].classList.remove(this._removeFromSiblings.class)
                }
            }
        }
    }
}

export default ChangeClass



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ChangeClass.js